import { Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InfoTooltip } from 'components/InfoTooltip';

export const WildfireStoppedInfo = (): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{
        bgcolor: theme.palette.background.inlineInfoCard,
        borderRadius: '8px',
        py: 1,
        px: 2,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: '500' }}>
        {t('geoEvent.stoppedTooltip.title')}
      </Typography>
      <InfoTooltip title={t('geoEvent.stoppedTooltip.description')} />
    </Stack>
  );
};
